import{_ as t,U as i}from"./__bundle-634b4c5b.js";var s=function(i){function s(t,s){var r,u=this;return(u=i.call(this,t,s)||this).isMuted=!1,u.isMuted=null!==(r=s.is_muted)&&void 0!==r&&r,u}return t(s,i),s}(i);export{s as P};
